/**
 * MY (马来西亚) 策略覆写
 * 导出同名方法以覆盖默认策略，命名规则同 diffconfig/config/strategy.ts：modulePageAction（小驼峰）
 */
export default {
  /**
   * 处理省市区地址列表
   */
  addressColumnRender(record: any): any {
    const { province, city, area, postalCode } = record
    return [postalCode,area, city, province].filter((_) => _).join(', ') || '--'
  }
}
